<template>
  <div>
    <!-- Filters -->
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col cols="12">
          <h3 class="ml-1 mb-2">
            الفلاتر
          </h3>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-input
            v-model="filter.search"
            placeholder="بحث سريع"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-input
            v-model="filter.requestnumber"
            placeholder="رقم الطلب"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-input
            v-model="filter.arabicfullname"
            placeholder="الاسم (عربي)"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.telephonenumber"
            placeholder="رقم الهاتف"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-select
            v-model="filter.confirmed"
            :options="confirmedOptions"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-select
            v-model="filter.per_page"
            :options="perPageOptions"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.gov"
            placeholder="المحافظة (gov)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.sec"
            placeholder="القطاع (sec)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.ssec"
            placeholder="القطاع الفرعي (ssec)"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.companyname"
            placeholder="الشركة"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.assign_status"
            placeholder="assign_status"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.survey_review_status"
            placeholder="survey_review_status"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mt-1"
        >
          <b-form-input
            v-model="filter.collect_status"
            placeholder="collect_status"
          />
        </b-col>
      </b-row>
    </b-card>

    <!-- Actions + Table -->
    <b-card class="w-100 d-flex rounded-lg">
      <b-row class="w-100">
        <b-col
          cols="12"
          class="pb-2 w-100 d-flex justify-content-end align-items-end"
        >
          <b-button
            v-if="hasPermission('create citizen_surveys')"
            class="btn rounded-pill ml-auto"
            variant="primary"
            @click="openImportModal"
          >
            <feather-icon
              icon="UploadIcon"
              size="18"
            />
            استيراد Excel
          </b-button>

          <!-- <b-button
            v-if="surveys && surveys.data && surveys.data.length"
            class="btn rounded-pill ml-1"
            variant="outline-primary"
            @click="exportCsv"
          >
            <feather-icon icon="DownloadIcon" size="18" />
            تصدير CSV
          </b-button> -->
        </b-col>
      </b-row>

      <div
        v-if="loadList"
        class="text-center"
        style="width: 100%;"
      >
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </div>

      <b-table
        v-else
        striped
        responsive
        :items="surveys ? surveys.data : []"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        no-local-sorting
        show-empty
        empty-text="لا توجد بيانات"
        @sort-changed="onSortChanged"
      >
        <template #cell(id)="data">
          <b-link
            class="text-primary"
            :to="{ name: 'citizen_survey_details', params: { id: data.item.id } }"
          >
            {{ data.item.id }}
          </b-link>
        </template>

        <template #cell(confirmed)="data">
          <b-badge :variant="data.item.confirmed ? 'success' : 'secondary'">
            {{ data.item.confirmed ? 'مؤكد' : 'غير مؤكد' }}
          </b-badge>
        </template>

        <template #cell(assign_status)="data">
          <b-badge :variant="statusVariant(data.item.assign_status)">
            {{ data.item.assign_status }}
          </b-badge>
        </template>
        <template #cell(survey_review_status)="data">
          <b-badge :variant="statusVariant(data.item.survey_review_status)">
            {{ data.item.survey_review_status }}
          </b-badge>
        </template>
        <template #cell(collect_status)="data">
          <b-badge :variant="statusVariant(data.item.collect_status)">
            {{ data.item.collect_status }}
          </b-badge>
        </template>
      </b-table>

      <b-pagination
        v-if="surveys && surveys.meta"
        v-model="pageProxy"
        align="center"
        :total-rows="surveys.meta.total"
        :per-page="surveys.meta.per_page"
        @change="onPageChange"
      />
    </b-card>

    <!-- Import Modal -->
    <b-modal
      id="citizen-surveys-import-modal"
      title="استيراد استبيانات المواطنين"
      size="lg"
      hide-footer
    >
      <b-form @submit.prevent="submitImport">
        <b-form-group
          label="اختر الملف"
          label-for="cs-file"
        >
          <b-form-file
            id="cs-file"
            v-model="importFile"
            accept=".xlsx,.xls"
            :disabled="loadImport"
            placeholder="اختر ملف Excel (.xlsx أو .xls)"
            drop-placeholder="اسحب الملف هنا"
          />
          <b-form-text v-if="importFile">
            الملف المحدد: {{ importFile.name }} ({{ formatFileSize(importFile.size) }})
          </b-form-text>
        </b-form-group>

        <!-- <b-form-group label="Dry run" label-for="cs-dry-run">
          <b-form-checkbox id="cs-dry-run" v-model="dryRun" switch :disabled="loadImport">
            تفعيل Dry run
          </b-form-checkbox> -->
        <b-form-text>
          عند التفعيل سيتم الفحص فقط بدون إنشاء/ربط مشاريع (إن كان مدعومًا من الخلفية).
        </b-form-text>
        </b-form-group>

        <b-card
          class="mt-1"
          body-class="p-1"
        >
          <b-card-title class="mb-1">
            البيانات الثابتة (تُطبق على كل المشاريع)
          </b-card-title>

          <b-row>
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                label="المهندس المسؤول"
                label-for="technical_responsible_id"
              >
                <v-select
                  id="technical_responsible_id"
                  v-model="importProjectFields.technical_responsible_id"
                  :options="employeesOptions"
                  :reduce="val => val.id"
                  label="name"
                  dir="rtl"
                  :clearable="true"
                  :disabled="loadImport"
                  :get-option-label="option => option.full_name"
                  @search="onEmployeeSearch"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                label="المسؤول عن الاتفاقية"
                label-for="office_agreement_responsible_id"
              >
                <v-select
                  id="office_agreement_responsible_id"
                  v-model="importProjectFields.office_agreement_responsible_id"
                  :options="employeesOptions"
                  :reduce="val => val.id"
                  label="name"
                  dir="rtl"
                  :clearable="true"
                  :get-option-label="option => option.full_name"
                  :disabled="loadImport"
                  @search="onEmployeeSearch"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                label="المسؤول عن الرسم"
                label-for="office_drawing_responsible_id"
              >
                <v-select
                  id="office_drawing_responsible_id"
                  v-model="importProjectFields.office_drawing_responsible_id"
                  :options="employeesOptions"
                  :reduce="val => val.id"
                  label="name"
                  dir="rtl"
                  :clearable="true"
                  :disabled="loadImport"
                  :get-option-label="option => option.full_name"
                  @search="onEmployeeSearch"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="فريق المعاينة"
                label-for="inspection_teams"
              >
                <v-select
                  id="inspection_teams"
                  v-model="importProjectFields.inspection_teams"
                  :options="employeesOptions"
                  :reduce="val => val.id"
                  label="name"
                  dir="rtl"
                  multiple
                  :close-on-select="false"
                  :clearable="true"
                  :disabled="loadImport"
                  :get-option-label="option => option.full_name"
                  @search="onEmployeeSearch"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                label="التكلفة الفعلية"
                label-for="actual_cost"
              >
                <b-form-input
                  id="actual_cost"
                  v-model="importProjectFields.actual_cost"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="loadImport"
                  placeholder="مثال: 1500"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                label="تكلفة السائق"
                label-for="driver_cost"
              >
                <b-form-input
                  id="driver_cost"
                  v-model="importProjectFields.driver_cost"
                  type="number"
                  min="0"
                  step="0.01"
                  :disabled="loadImport"
                  placeholder="مثال: 200"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="عميل مفوض بالحساب"
                label-for="authorized_client_id"
              >
                <v-select
                  id="authorized_client_id"
                  v-model="importProjectFields.authorized_client_id"
                  :options="customersOptions"
                  :reduce="val => val.id"
                  label="name"
                  dir="rtl"
                  :clearable="true"
                  :disabled="loadImport"
                  @search="onCustomerSearch"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <div class="d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            :disabled="loadImport"
            @click="closeImportModal"
          >
            إلغاء
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="!importFile || loadImport"
          >
            <b-spinner
              v-if="loadImport"
              small
              class="mr-50"
            />
            رفع الملف
          </b-button>
        </div>
      </b-form>

      <!-- Results -->
      <b-card
        v-if="importResult"
        class="mt-2"
      >
        <b-card-title class="mb-1">
          نتائج الاستيراد
        </b-card-title>

        <div v-if="importResult.import">
          <h5 class="mt-1 mb-1">
            ملخص الاستيراد
          </h5>
          <b-row class="mb-1">
            <b-col
              cols="12"
              md="4"
            >
              <b-card class="text-center bg-light-primary">
                <h4 class="mb-0">
                  {{ importResult.import.total || 0 }}
                </h4>
                <small>إجمالي الصفوف</small>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-card class="text-center bg-light-success">
                <h4 class="mb-0">
                  {{ importResult.import.imported || 0 }}
                </h4>
                <small>تم الاستيراد</small>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-card class="text-center bg-light-danger">
                <h4 class="mb-0">
                  {{ importResult.import.errors || 0 }}
                </h4>
                <small>أخطاء</small>
              </b-card>
            </b-col>

          </b-row>
        </div>

        <div v-if="importResult.projects">
          <h5 class="mt-2 mb-1">
            ملخص المشاريع
          </h5>
          <b-row class="mb-1">
            <b-col
              cols="12"
              md="3"
            >
              <b-card class="text-center bg-light-secondary">
                <h4 class="mb-0">
                  {{ importResult.projects.processed || 0 }}
                </h4>
                <small>Processed</small>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <b-card class="text-center bg-light-success">
                <h4 class="mb-0">
                  {{ importResult.projects.created || 0 }}
                </h4>
                <small>Created</small>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <b-card class="text-center bg-light-info">
                <h4 class="mb-0">
                  {{ importResult.projects.linked || 0 }}
                </h4>
                <small>Linked</small>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <b-card class="text-center bg-light-warning">
                <h4 class="mb-0">
                  {{ importResult.projects.skipped || 0 }}
                </h4>
                <small>Skipped</small>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <div v-if="errorDetailsRows.length">
          <h5 class="mt-2 mb-1 text-danger">
            تفاصيل الأخطاء
          </h5>
          <b-table
            :items="errorDetailsRows"
            :fields="errorDetailsFields"
            small
            responsive
            striped
            hover
          />
        </div>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BButton,
  BSpinner,
  BPagination,
  BFormInput,
  BFormSelect,
  BLink,
  BBadge,
  BModal,
  BForm,
  BFormGroup,
  BFormFile,
  BFormText,
  BFormCheckbox,
  BCardTitle,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'CitizenSurveysList',
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BSpinner,
    BPagination,
    BFormInput,
    BFormSelect,
    BLink,
    BBadge,
    BModal,
    BForm,
    BFormGroup,
    BFormFile,
    BFormText,
    BFormCheckbox,
    BCardTitle,
    vSelect,
  },
  computed: {
    ...mapGetters({
      surveys: 'citizenSurveys/surveys',
      loadList: 'citizenSurveys/loadList',
      loadImport: 'citizenSurveys/loadImport',
      importResult: 'citizenSurveys/importResult',
    }),
    employees() {
      return this.$store.getters['employees/employees']
    },
    customers() {
      return this.$store.getters['customers/customers']
    },
    employeesOptions() {
      return this.employees && this.employees.data ? this.employees.data : []
    },
    customersOptions() {
      return this.customers && this.customers.data ? this.customers.data : []
    },
    pageProxy: {
      get() {
        return this.surveys?.meta?.current_page || 1
      },
      set() {},
    },
    errorDetailsRows() {
      const fromImport = this.importResult?.import?.error_details || []
      const fromProjects = this.importResult?.projects?.error_details || []
      // normalize to table rows
      const rows = []
      fromImport.forEach(e => rows.push({ scope: 'import', ...e }))
      fromProjects.forEach(e => rows.push({ scope: 'projects', ...e }))
      return rows
    },
  },
  data() {
    return {
      // list filter params (server-side)
      filter: {
        search: null,
        requestnumber: null,
        arabicfullname: null,
        telephonenumber: null,
        gov: null,
        sec: null,
        ssec: null,
        companyname: null,
        assign_status: null,
        survey_review_status: null,
        collect_status: null,
        confirmed: null,
        sort_by: null,
        sort_order: null,
        per_page: 15,
        page: 1,
      },
      perPageOptions: [
        { value: 10, text: '10' },
        { value: 15, text: '15' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
      ],
      confirmedOptions: [
        { value: null, text: 'التأكيد: الكل' },
        { value: 1, text: 'مؤكد' },
        { value: 0, text: 'غير مؤكد' },
      ],
      fields: [
        // { key: 'id', label: '#', sortable: true },
        { key: 'requestnumber', label: 'رقم الطلب', sortable: true },
        { key: 'arabicfullname', label: 'الاسم', sortable: true },
        { key: 'telephonenumber', label: 'الهاتف', sortable: true },
        { key: 'gov', label: 'المحافظة', sortable: true },
        { key: 'sec', label: 'القطاع', sortable: true },
        { key: 'ssec', label: 'القطاع الفرعي', sortable: true },
        { key: 'companyname', label: 'الشركة', sortable: true },
        { key: 'assign_status', label: 'Assign', sortable: true },
        { key: 'survey_review_status', label: 'Review', sortable: true },
        { key: 'collect_status', label: 'Collect', sortable: true },
        { key: 'confirmed', label: 'Confirmed', sortable: true },
      ],
      sortBy: null,
      sortDesc: false,

      // import
      importFile: null,
      dryRun: false,
      importProjectFields: {
        technical_responsible_id: null,
        office_agreement_responsible_id: null,
        office_drawing_responsible_id: null,
        inspection_teams: [],
        actual_cost: null,
        driver_cost: null,
        authorized_client_id: null,
      },
      errorDetailsFields: [
        { key: 'scope', label: 'Scope' },
        { key: 'row', label: 'Row' },
        { key: 'error', label: 'Error' },
      ],
      searchTimeout: null,
    }
  },
  watch: {
    'filter.search': function () {
      this.debouncedRefresh()
    },
    'filter.requestnumber': function () {
      this.debouncedRefresh()
    },
    'filter.arabicfullname': function () {
      this.debouncedRefresh()
    },
    'filter.telephonenumber': function () {
      this.debouncedRefresh()
    },
    'filter.gov': function () {
      this.debouncedRefresh()
    },
    'filter.sec': function () {
      this.debouncedRefresh()
    },
    'filter.ssec': function () {
      this.debouncedRefresh()
    },
    'filter.companyname': function () {
      this.debouncedRefresh()
    },
    'filter.assign_status': function () {
      this.debouncedRefresh()
    },
    'filter.survey_review_status': function () {
      this.debouncedRefresh()
    },
    'filter.collect_status': function () {
      this.debouncedRefresh()
    },
    'filter.confirmed': function () {
      this.refresh({ page: 1 })
    },
    'filter.per_page': function () {
      this.refresh({ page: 1 })
    },
  },
  created() {
    this.debouncedRefresh = this.debounce(() => this.refresh({ page: 1 }), 400)
  },
  mounted() {
    this.refresh({ page: 1 })
  },
  methods: {
    cleanQuery(obj) {
      const q = {}
      Object.keys(obj || {}).forEach(k => {
        const v = obj[k]
        if (v === null || v === undefined) return
        if (typeof v === 'string' && v.trim() === '') return
        q[k] = v
      })
      return q
    },
    refresh({ page } = {}) {
      const query = this.cleanQuery({
        ...this.filter,
        page: page || this.filter.page || 1,
      })
      this.filter.page = query.page
      this.$store.dispatch('citizenSurveys/listSurveys', { query })
    },
    onPageChange(page) {
      this.refresh({ page })
    },
    onSortChanged(ctx) {
      // ctx: { sortBy, sortDesc }
      this.sortBy = ctx.sortBy || null
      this.sortDesc = !!ctx.sortDesc
      this.filter.sort_by = this.sortBy
      this.filter.sort_order = this.sortDesc ? 'desc' : 'asc'
      this.refresh({ page: 1 })
    },
    openImportModal() {
      // Preload dropdown data
      this.$store.dispatch('employees/listEmployees', { query: {} })
      this.$store.dispatch('customers/listCustomers', { query: {} })
      this.$bvModal.show('citizen-surveys-import-modal')
    },
    closeImportModal() {
      this.$bvModal.hide('citizen-surveys-import-modal')
    },
    submitImport() {
      if (!this.importFile) return
      const inspection_teams = Array.isArray(this.importProjectFields.inspection_teams) && this.importProjectFields.inspection_teams.length
        ? this.importProjectFields.inspection_teams
        : undefined

      this.$store
        .dispatch('citizenSurveys/importSurveys', {
          file: this.importFile,
          dry_run: this.dryRun ? 1 : 0,
          ...this.importProjectFields,
          inspection_teams,
        })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res?.message || 'تم رفع الملف',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          // refresh list after import
          this.refresh({ page: 1 })
        })
        .catch(err => {
          const msg = err?.response?.data?.message || err?.message || 'حدث خطأ أثناء الاستيراد'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطأ',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: msg,
            },
          })
        })
    },
    exportCsv() {
      const rows = (this.surveys?.data || []).map(r => ({
        id: r.id ?? '',
        requestnumber: r.requestnumber ?? '',
        arabicfullname: r.arabicfullname ?? '',
        telephonenumber: r.telephonenumber ?? '',
        gov: r.gov ?? '',
        sec: r.sec ?? '',
        ssec: r.ssec ?? '',
        companyname: r.companyname ?? '',
        assign_status: r.assign_status ?? '',
        survey_review_status: r.survey_review_status ?? '',
        collect_status: r.collect_status ?? '',
        confirmed: r.confirmed ? 1 : 0,
      }))

      const headers = Object.keys(rows[0] || {})
      if (!headers.length) return

      const csvRows = []
      csvRows.push(headers.join(','))
      rows.forEach(row => {
        const line = headers
          .map(h => `"${String(row[h] ?? '').replace(/"/g, '""')}"`)
          .join(',')
        csvRows.push(line)
      })
      const csvContent = csvRows.join('\n')
      const blob = new Blob([`\ufeff${csvContent}`], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `citizen_surveys_${new Date().getTime()}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    formatFileSize(bytes) {
      if (!bytes && bytes !== 0) return ''
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      if (bytes === 0) return '0 Byte'
      const i = Math.floor(Math.log(bytes) / Math.log(1024))
      return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`
    },
    statusVariant(val) {
      const v = String(val || '').toLowerCase()
      if (['done', 'approved', 'confirmed', 'completed', 'success', 'yes', 'true', '1'].includes(v)) return 'success'
      if (['pending', 'new', 'in_progress', 'processing', 'review'].includes(v)) return 'warning'
      if (['rejected', 'failed', 'error', 'no', 'false', '0'].includes(v)) return 'danger'
      return 'secondary'
    },
    debounce(fn, wait) {
      let t
      return (...args) => {
        clearTimeout(t)
        t = setTimeout(() => fn.apply(this, args), wait)
      }
    },
    onEmployeeSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        const query = search ? { search } : {}
        this.$store.dispatch('employees/listEmployees', { query }).finally(() => {
          if (loading) loading(false)
        })
      }, 300)
    },
    onCustomerSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        const query = search ? { search } : {}
        this.$store.dispatch('customers/listCustomers', { query }).finally(() => {
          if (loading) loading(false)
        })
      }, 300)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
